import React from 'react'
import axios from "../axios";
import { useSelector } from 'react-redux';

export default function ReopenTicket({ data,close,refetching }) {
    const userId = useSelector((state) => state?.user?.currentUser?.id);
    const handleReopen=async()=>{
        try {
            let response = await axios.put(`/ticket/updateStatusForStudent/${data.id}`, 
                 {
                  "status": "pending"
                }
              );
              if (response) {
                close();
                refetching();
              }
              
            // console.log(object);
        } catch (error) {
            throw error;
        }
    }
    return (
        <div className='ContainerCreateDeleteCommunity'>
            <div className='SubContainerCreateDeleteCommunity'>
                <div onClick={()=>{close()}}>
                    <img style={{ cursor: 'pointer' }} className='CrossIconPost' src='/Enggagement/crossCirclePost.png' alt=''></img>
                </div>
                <div className='d-flex justify-content-center msgDeleteHeading'>
                    Are you sure you want to reopen this ticket?
                </div>
                <div className='d-flex gap-3 mt-4 pt-4 justify-content-center'>
                    <button className='DeleteYesBtn' onClick={()=>{handleReopen()}}>Yes</button>
                    <button className='DeleteNoBtn' onClick={()=>{close()}}>No</button>
                </div>
            </div>
        </div>
    )
}
